import React from 'react';
import Joyride, { CallBackProps, Placement } from 'react-joyride';
import { Subtext } from '@ui-library/typography';
import { useTheme } from 'styled-components';

interface Props {
  onClose: () => void;
  spotlight: {
    placement?: Placement;
    className: string;
    padding?: number;
    offset?: number;
  };
  text: string | JSX.Element;
  // To focus on a specific element within the spotlight
  tooltip?: {
    id: string;
    placement: 'bottom' | 'top';
  };
}

export const CoachMark = ({ onClose, tooltip, spotlight, text }: Props) => {
  const { token } = useTheme();

  const styles = {
    buttonClose: {
      top: 6,
      right: 8,
      padding: 0,
      color: 'white',
      width: 10,
      height: 10,
    },
    tooltipContent: {
      padding: 0,
    },
    tooltip: {
      borderRadius: token.borderRadiusLG,
      padding: '12px 26px 12px 12px',
    },
    tooltipContainer: {
      textAlign: 'left' as const,
    },
    options: {
      width: 230,
      backgroundColor: token.colorPrimary,
      arrowColor: token.colorPrimary,
      borderRadius: token.borderRadiusLG,
    },
  };

  const handleCallback = (data: CallBackProps) => {
    if (data.action === 'close') {
      onClose();
    }
  };

  const options = {
    steps: [
      {
        disableBeacon: true,
        hideFooter: true,
        spotlightClicks: true,
        placement: spotlight.placement,
        target: `.${spotlight.className}`,
        offset: spotlight.offset || 10,
        content: <Subtext color={token.colorTextLightSolid}>{text}</Subtext>,
      },
    ],
    ...(!!tooltip && {
      floaterProps: {
        target: `#${tooltip.id}`,
        placement: tooltip.placement,
      },
    }),
  };

  return (
    <Joyride
      callback={handleCallback}
      {...options}
      styles={styles}
      disableScrolling
      spotlightPadding={spotlight.padding || 0}
    />
  );
};
